module.exports = __webpack_public_path__ + "static/media/ayoka_clientLogo.207363d6.png";